import { Injectable } from '@angular/core';
import { Payment, PaymentAPIResponse } from '../interfaces/payment';

@Injectable({
  providedIn: 'root',
})
export class PaymentAdapter {
  public adapterToModel(paymentAPI: PaymentAPIResponse): Payment {
    return {
      payment_id: paymentAPI?.payment_id,
      order_id: paymentAPI?.order_id,
      charge_id: paymentAPI?.charge_id,
      provider: paymentAPI?.provider,
      payment_method: paymentAPI?.payment_method,
      expires_at: paymentAPI?.expires_at || paymentAPI?.qrcode?.expiration || paymentAPI?.due_at,
      boleto_url: paymentAPI?.boleto_url || paymentAPI?.qrcode?.ticket_url,
      boleto_barcode: paymentAPI?.boleto_barcode,
      pix_qr_code: paymentAPI?.pix_qr_code || paymentAPI?.qrcode?.code,
      pix_qr_code_base64: paymentAPI?.pix_qr_code_base64 || paymentAPI?.qrcode?.base64,
      status_reason: paymentAPI?.status_reason,
      healthcareservice_name: paymentAPI.healthcareservice_name,
      encounter_id: paymentAPI.encounter_id,
      value: paymentAPI.value,
      status: paymentAPI.status,
      billingType: paymentAPI.billingType,
      customer_info: paymentAPI.customer_info,
      credit_card: paymentAPI?.credit_card,
      qrcode: paymentAPI.qrcode,
      card_info: paymentAPI.card_info,
      card_token: paymentAPI.card_token,
      card_id: paymentAPI.card_id,
      installments: paymentAPI.installments,
      payment_at: paymentAPI?.payment_at,
      due_at: paymentAPI.due_at,
      confirmed_by: paymentAPI?.confirmed_by,
      confirmed_at: paymentAPI?.confirmed_at,
      confirmation_code: paymentAPI?.confirmation_code,
      code: paymentAPI?.code,
      items: paymentAPI?.items,
      customer: paymentAPI?.customer,
      payments: paymentAPI?.payments,
      closed: paymentAPI?.closed,
      metadata: paymentAPI?.metadata,
    };
  }

  public adaptToAPIFormat(paymentModel: Payment): PaymentAPIResponse {
    return {
      payment_id: paymentModel?.payment_id,
      order_id: paymentModel?.order_id,
      charge_id: paymentModel?.charge_id,
      provider: paymentModel?.provider,
      payment_method: paymentModel?.payment_method,
      expires_at: paymentModel?.expires_at,
      boleto_url: paymentModel?.boleto_url,
      boleto_barcode: paymentModel?.boleto_barcode,
      pix_qr_code: paymentModel?.pix_qr_code,
      pix_qr_code_base64: paymentModel?.pix_qr_code_base64,
      status_reason: paymentModel?.status_reason,
      healthcareservice_name: paymentModel?.healthcareservice_name,
      value: paymentModel.value,
      status: paymentModel.status,
      billingType: paymentModel.billingType,
      due_at: paymentModel.due_at,
      customer_info: paymentModel?.customer_info,
      credit_card: paymentModel?.credit_card,
      card_info: paymentModel.card_info,
      card_token: paymentModel.card_token,
      card_id: paymentModel.card_id,
      installments: paymentModel.installments,
      qrcode: paymentModel.qrcode,
      encounter_id: paymentModel?.encounter_id,
      confirmed_by: paymentModel?.confirmed_by,
      confirmed_at: paymentModel?.confirmed_at,
      confirmation_code: paymentModel?.confirmation_code,
      code: paymentModel?.code,
      items: paymentModel?.items,
      customer: paymentModel?.customer,
      payments: paymentModel?.payments,
      closed: paymentModel?.closed,
      metadata: paymentModel?.metadata,
    };
  }
}
